// @vendors
import React, { useEffect, useState, useContext } from "react";
import Context from "../../context/appContext";
import { Button, Dropdown, Menu } from "antd";

// @styles
import "./styles.scss";
import { Fade } from "react-reveal";

export default function Header() {
  const { tokenInfo, setTokenInfo, homePageData, showHomePage } = useContext(Context);
  const [userInfo, setUserInfo] = useState({});
  const [openMenu, setOpenMenu] = useState(false);

  const logout = () => {
    localStorage.clear();
    window.location.href = process.env.REACT_APP_URL_REDIRECT;
  }

  const menu = tokenInfo.usuarioId ? (
    <Menu>
      <Menu.Item key="infoLogout" className="user-info">
        <strong>Usuario: </strong>
        <br />
        {userInfo && userInfo.usuarioId
          ? userInfo.usuarioId
          : tokenInfo.usuarioId}
      </Menu.Item>
      <Menu.Item key="iconLogout" className="close-sesion" onClick={logout}>
        <em className="fal fa-sign-out-alt" />
        Cerrar sesión
      </Menu.Item>
    </Menu>
  ) : <></>;

  useEffect(() => {
    if (tokenInfo && !tokenInfo.name) {
      document.title = 'Contrata tu seguro - Seguros SURA';
      const channelValues = JSON.parse(process.env.REACT_APP_CHANNEL_VALUES_DIRECT);
      const info = {
        name: process.env.REACT_APP_DEFAULT_NAME,
        usuarioId: null,
        atrPuntoVentaId: null,
        atrGrupoId: null,
        atrSubgrupoId: null,
        atrPerfilTarifaId: null,
        email: process.env.REACT_APP_DEFAULT_EMAIL,
        oficinaId: channelValues && channelValues.oficina,
        ramoId: channelValues && channelValues.ramo
      };
      setUserInfo(info);
      setTokenInfo(info);
    } else {
      if (tokenInfo && tokenInfo.usuarioId) {
        document.title = 'Cotizador Agentes - Seguros SURA';
      }
      setUserInfo({});
    }
  }, [tokenInfo]);

  const getLink = (link) => {
    return link ? link.indexOf('#') !== -1 ? link.replace('https://', '') : link : '#';
  }

  return (
    <header className="header-ppal" id="top">
      <div className="container-xl">
        <Fade top cascade delay={0.3}>
          <a onClick={() => window.location.reload(false)}>
            {homePageData && homePageData.logo && (<img
              src={homePageData.logo.url}
              alt={homePageData?.logo?.alt}
              className="header-ppal__logo"
            />)}
          </a>
        </Fade>
        {(tokenInfo.usuarioId && (homePageData.links === null || !showHomePage)) && (
          <Fade top delay={0.3}>
            <Dropdown overlay={menu} trigger='click'>
              <div className='header-ppal__user'>
                <div className='header-ppal__user-data'>
                  <strong>{tokenInfo.name}</strong>
                </div>
                <div className='header-ppal__user-photo'>
                  <em className='fal fa-user' />
                </div>
                <em className='fal fa-chevron-down' />
              </div>
            </Dropdown>
          </Fade>
        )}
        {(!tokenInfo.usuarioId && showHomePage && homePageData.links) && (
          <div className="header-ppal-links">
            {homePageData.links && homePageData.links.length > 0 &&
              homePageData.links.map((item) =>
                item.typemenuitem === "Link" ? (<Fade top delay={0.3}><a href={getLink(item.linkmenuitem.url)} className="header-ppal-links-page">{item.titlemenuitem}</a></Fade>) :
                  (<Fade top delay={0.3}><Button className="ant-btn-outline c-2 ant-btn-size-xs" href={getLink(item.linkmenuitem.url)}>
                    {item.titlemenuitem}
                  </Button></Fade>)
              )}
            <div data-testid="hamburger-btn" className={`hamburguer ${openMenu && 'open'}`} onClick={() => setOpenMenu(!openMenu)}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className={`navigation-mobile ${openMenu && 'open'}`}>
              <ul className="menu-mobile">
                {homePageData.links && homePageData.links.length > 0 &&
                  homePageData.links.map((item, index) =>
                    item.typemenuitem === "Link" ? (
                      <li className="nav-item" key={index}>
                        <a href={getLink(item.linkmenuitem.url)} className="header-ppal-links-page">{item.titlemenuitem}</a>
                      </li>) :
                      ('')
                  )}
              </ul>
            </div>
          </div>

        )}
      </div>
    </header >
  );
}
